import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  ArrowLeft,
  Bell,
  CalendarDays,
  ChevronDown,
  Clock3,
  FileText,
  FilePlus2,
  Gavel,
  LogOut,
  Menu,
  MessageSquarePlus,
  Plus,
  Search,
  ShieldCheck,
  Upload,
  UserRound,
  X,
} from 'lucide-react';
import { clientInfo, mockCases, powerOfAttorneys, serviceRequests } from '../../data/mockCases';

const STATUS_STYLES = {
  ar: {
    'ظ‚ظٹط¯ ط§ظ„ظ…ط¹ط§ظ„ط¬ط©': {
      tone: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
      dot: 'bg-emerald-500',
    },
    'ط¨ط§ظ†طھط¸ط§ط± ط¥ط¬ط±ط§ط،': {
      tone: 'bg-amber-50 text-amber-700 border border-amber-200',
      dot: 'bg-amber-500',
    },
    'ظ…طھط£ط®ط±ط©': {
      tone: 'bg-rose-50 text-rose-700 border border-rose-200',
      dot: 'bg-rose-500',
    },
    'ظ…ط؛ظ„ظ‚ط©': {
      tone: 'bg-slate-100 text-slate-600 border border-slate-200',
      dot: 'bg-slate-400',
    },
  },
  en: {
    'In Progress': {
      tone: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
      dot: 'bg-emerald-500',
    },
    'Awaiting Action': {
      tone: 'bg-amber-50 text-amber-700 border border-amber-200',
      dot: 'bg-amber-500',
    },
    Overdue: {
      tone: 'bg-rose-50 text-rose-700 border border-rose-200',
      dot: 'bg-rose-500',
    },
    Closed: {
      tone: 'bg-slate-100 text-slate-600 border border-slate-200',
      dot: 'bg-slate-400',
    },
  },
};

const TAB_META = {
  ar: {
    cases: {
      label: 'ط§ظ„ظ‚ط¶ط§ظٹط§',
      title: 'ظ‚ط¶ط§ظٹط§ظٹ',
      description: 'طھط§ط¨ط¹ ظ…ظ„ظپط§طھظƒ ط§ظ„ظ‚ط¶ط§ط¦ظٹط©طŒ ط­ط§ظ„طھظ‡ط§طŒ ظˆط¢ط®ط± ط¥ط¬ط±ط§ط، طھظ… ط¹ظ„ظٹظ‡ط§ ط¨ظˆط¶ظˆط­.',
      searchPlaceholder: 'ط§ط¨ط­ط« ط¨ط±ظ‚ظ… ط§ظ„ظ‚ط¶ظٹط© ط£ظˆ ط§ط³ظ… ط§ظ„ط·ط±ظپ',
      counterpartLabel: 'ط§ظ„ط·ط±ظپ ط§ظ„ط¢ط®ط±',
      typeLabel: 'ظ†ظˆط¹ ط§ظ„ظ‚ط¶ظٹط©',
    },
    execution: {
      label: 'ط§ظ„طھظ†ظپظٹط°',
      title: 'ط·ظ„ط¨ط§طھ ط§ظ„طھظ†ظپظٹط°',
      description: 'ط§ط³طھط¹ط±ط¶ ط·ظ„ط¨ط§طھ ط§ظ„طھظ†ظپظٹط° ط§ظ„ط¬ط§ط±ظٹط©طŒ ط­ط§ظ„طھظ‡ط§طŒ ظˆظ…ط§ ظٹظ„ط²ظ… ظ„ط§ط³طھظƒظ…ط§ظ„ظ‡ط§.',
      searchPlaceholder: 'ط§ط¨ط­ط« ط¨ط±ظ‚ظ… ط·ظ„ط¨ ط§ظ„طھظ†ظپظٹط° ط£ظˆ ط§ظ„ط¬ظ‡ط©',
      counterpartLabel: 'ط§ظ„ط¬ظ‡ط© ط§ظ„ظ…ظ†ظپط° ط¶ط¯ظ‡ط§',
      typeLabel: 'ظ†ظˆط¹ ط§ظ„ط·ظ„ط¨',
    },
    insolvency: {
      label: 'ط§ظ„ط¥ظپظ„ط§ط³ ظˆط§ظ„طھطµظپظٹط©',
      title: 'ط§ظ„ط¥ظپظ„ط§ط³ ظˆط§ظ„طھطµظپظٹط©',
      description: 'طھط§ط¨ط¹ ظ…ظ„ظپط§طھ ط§ظ„ط¥ظپظ„ط§ط³ ظˆط§ظ„طھطµظپظٹط©طŒ ظ…ط±ط§ط­ظ„ظ‡ط§طŒ ظˆط£ظ‡ظ… ط§ظ„طھط­ط¯ظٹط«ط§طھ ط§ظ„ظ…ط±طھط¨ط·ط© ط¨ظ‡ط§.',
      searchPlaceholder: 'ط§ط¨ط­ط« ط¨ط±ظ‚ظ… ط§ظ„ظ…ظ„ظپ ط£ظˆ ط§ط³ظ… ط§ظ„ط¬ظ‡ط©',
      counterpartLabel: 'ط§ظ„ط¬ظ‡ط© ط§ظ„ظ…ظ‚ط§ط¨ظ„ط©',
      typeLabel: 'ظ†ظˆط¹ ط§ظ„ظ…ظ„ظپ',
    },
    poa: {
      label: 'ط§ظ„ظˆظƒط§ظ„ط§طھ',
      title: 'ط§ظ„ظˆظƒط§ظ„ط§طھ',
      description: 'ط§ط·ظ‘ظ„ط¹ ط¹ظ„ظ‰ ط§ظ„ظˆظƒط§ظ„ط§طھ ط§ظ„طµط§ط¯ط±ط© ظ„ظƒ ط£ظˆ ظ…ظ†ظƒطŒ ظˆط­ط§ظ„طھظ‡ط§ ظˆط¢ط®ط± طھط­ط¯ظٹط« ط¹ظ„ظٹظ‡ط§.',
      searchPlaceholder: 'ط§ط¨ط­ط« ط¨ط±ظ‚ظ… ط§ظ„ظˆظƒط§ظ„ط© ط£ظˆ ط§ط³ظ… ط§ظ„ط¬ظ‡ط©',
      counterpartLabel: 'ط§ظ„ط¬ظ‡ط© ط§ظ„ظ…ط±طھط¨ط·ط©',
      typeLabel: 'ظ†ظˆط¹ ط§ظ„ظˆظƒط§ظ„ط©',
    },
    tickets: {
      label: 'ط§ظ„طھط°ط§ظƒط±',
      title: 'ط§ظ„ط´ظƒط§ظˆظ‰ ظˆط§ظ„ط§ظ‚طھط±ط§ط­ط§طھ',
      description: 'ظ‚ط¯ظ‘ظ… ط´ظƒظˆط§ظƒ ط£ظˆ ط§ظ‚طھط±ط§ط­ظƒطŒ ظˆطھط§ط¨ط¹ ط§ظ„طھط­ط¯ظٹط«ط§طھ ط§ظ„ظ…ط±طھط¨ط·ط© ط¨ظ‡ط§ ظ…ظ† ظ…ظƒط§ظ† ظˆط§ط­ط¯.',
      searchPlaceholder: 'ط§ط¨ط­ط« ط¨ط±ظ‚ظ… ط§ظ„طھط°ظƒط±ط© ط£ظˆ ظ…ظˆط¶ظˆط¹ظ‡ط§',
      counterpartLabel: 'ط§ظ„ط¬ظ‡ط© ط§ظ„ظ…ط®طھطµط©',
      typeLabel: 'ظ†ظˆط¹ ط§ظ„طھط°ظƒط±ط©',
    },
  },
  en: {
    cases: {
      label: 'Cases',
      title: 'My Cases',
      description: 'Track your legal files, their status, and the latest action taken on each one.',
      searchPlaceholder: 'Search by case number or party name',
      counterpartLabel: 'Other Party',
      typeLabel: 'Case Type',
    },
    execution: {
      label: 'Enforcement',
      title: 'Enforcement Requests',
      description: 'Review active enforcement requests, their status, and what is needed next.',
      searchPlaceholder: 'Search by enforcement number or party',
      counterpartLabel: 'Respondent',
      typeLabel: 'Request Type',
    },
    insolvency: {
      label: 'Insolvency & Liquidation',
      title: 'Insolvency & Liquidation',
      description: 'Review insolvency and liquidation files, their stages, and latest updates.',
      searchPlaceholder: 'Search by file number or entity',
      counterpartLabel: 'Counterparty',
      typeLabel: 'File Type',
    },
    poa: {
      label: 'POAs',
      title: 'Powers of Attorney',
      description: 'Review powers of attorney issued for you or by you, with their latest updates.',
      searchPlaceholder: 'Search by POA number or entity',
      counterpartLabel: 'Related Party',
      typeLabel: 'POA Type',
    },
    tickets: {
      label: 'Tickets',
      title: 'Complaints & Suggestions',
      description: 'Submit and follow your complaints or suggestions from one organized place.',
      searchPlaceholder: 'Search by ticket number or subject',
      counterpartLabel: 'Assigned Team',
      typeLabel: 'Ticket Type',
    },
  },
};

const WAZIN_ICON_URL =
  'https://customer-assets.emergentagent.com/job_5ad4f013-9db1-4f9c-b371-b988a841f7e1/artifacts/nmtmq4a0_%D8%A7%D9%8A%D9%82%D9%88%D9%86%D8%A9%20%D8%A7%D9%84%D8%B4%D8%B9%D8%A7%D8%B1.png';

const LABELS = {
  ar: {
    greeting: 'ظ…ط±ط­ط¨ظ‹ط§طŒ',
    headerDescription: 'ظ‡ظ†ط§ طھط¬ط¯ ط¢ط®ط± ظ…ط³طھط¬ط¯ط§طھ ظ…ظ„ظپط§طھظƒ ط§ظ„ظ‚ط§ظ†ظˆظ†ظٹط©طŒ ظˆظ…ط§ ظٹطھط·ظ„ط¨ ط¥ط¬ط±ط§ط،ظƒطŒ ظˆط®ط¯ظ…ط§طھظƒ ط§ظ„ظ…ط±طھط¨ط·ط© ط¨ظˆط§ط²ظ†.',
    lastActivity: 'ط¢ط®ط± ظ†ط´ط§ط·',
    todayAt: 'ط§ظ„ظٹظˆظ… 10:45 طµط¨ط§ط­ظ‹ط§',
    profile: 'ط§ظ„ظ…ظ„ظپ ط§ظ„ط´ط®طµظٹ',
    updateData: 'طھط­ط¯ظٹط« ط§ظ„ط¨ظٹط§ظ†ط§طھ',
    changePhoto: 'طھط؛ظٹظٹط± طµظˆط±ط© ط§ظ„ط­ط³ط§ط¨',
    switchAccount: 'طھط¨ط¯ظٹظ„ ط§ظ„ط­ط³ط§ط¨ / ط§ظ„طµظ„ط§ط­ظٹط©',
    logout: 'طھط³ط¬ظٹظ„ ط§ظ„ط®ط±ظˆط¬',
    clientAccount: 'ط­ط³ط§ط¨ ط§ظ„ط¹ظ…ظٹظ„',
    cases: 'ط§ظ„ظ‚ط¶ط§ظٹط§',
    requests: 'ط§ظ„ط·ظ„ط¨ط§طھ',
    agencies: 'ط§ظ„ظˆظƒط§ظ„ط§طھ',
    documents: 'ط§ظ„ظ…ط³طھظ†ط¯ط§طھ',
    role: 'ط§ظ„طµظپط©',
    status: 'ط§ظ„ط­ط§ظ„ط©',
    latestUpdate: 'ط¢ط®ط± طھط­ط¯ظٹط«',
    nextStep: 'ط§ظ„ط®ط·ظˆط© ط§ظ„ظ‚ط§ط¯ظ…ط©',
    file: 'ط§ظ„ظ…ظ„ظپ',
    noResults: 'ظ„ط§ طھظˆط¬ط¯ ظ†طھط§ط¦ط¬ ظ…ط·ط§ط¨ظ‚ط©',
    noResultsDesc: 'ط¬ط±ظ‘ط¨ طھط¹ط¯ظٹظ„ ط§ظ„ط¨ط­ط« ط£ظˆ طھط؛ظٹظٹط± ط§ظ„ظپظ„طھط±ط© ظ„ط¹ط±ط¶ ظ…ظ„ظپط§طھ ط£ط®ط±ظ‰.',
    addTicket: 'ط¥ط¶ط§ظپط© طھط°ظƒط±ط©',
    addNewCase: 'ط¥ط¶ط§ظپط© ظ‚ط¶ظٹط© ط¬ط¯ظٹط¯ط©',
    addExecutionRequest: 'ط·ظ„ط¨ طھظ†ظپظٹط° ط¬ط¯ظٹط¯',
    all: 'ط§ظ„ظƒظ„',
    principal: 'ظ…ظˆظƒظ„',
    agent: 'ظˆظƒظٹظ„',
    legalServiceRequest: 'ط·ظ„ط¨ ط®ط¯ظ…ط© ظ‚ط§ظ†ظˆظ†ظٹط©',
    serviceRequestTitle: 'ط·ظ„ط¨ ط®ط¯ظ…ط© ظ‚ط§ظ†ظˆظ†ظٹط©',
    requestType: 'ظ†ظˆط¹ ط§ظ„ط·ظ„ط¨',
    issueDescription: 'ظˆطµظپ ط§ظ„ظ…ط´ظƒظ„ط©',
    legalBasis: 'ط§ظ„ط£ط³ط§ط³ ط§ظ„ظ†ط¸ط§ظ…ظٹ (ط§ط®طھظٹط§ط±ظٹ)',
    attachments: 'ط§ظ„ظ…ط±ظپظ‚ط§طھ',
    serviceType: 'ظ†ظˆط¹ ط§ظ„ط®ط¯ظ…ط© ط§ظ„ظ…ط·ظ„ظˆط¨ط©',
    initialAssessment: 'ط£ط±ط؛ط¨ ظپظٹ طھظ‚ظٹظٹظ… ط£ظˆظ„ظٹ ظ‚ط¨ظ„ ط§ظ„ط¨ط¯ط،',
    sendRequest: 'ط¥ط±ط³ط§ظ„ ط§ظ„ط·ظ„ط¨',
    quoteRequest: 'ط·ظ„ط¨ ط¹ط±ط¶ ط³ط¹ط±',
    issuePlaceholder: 'ط§ط´ط±ط­ ظ…ظˆط¶ظˆط¹ظƒ ط§ظ„ظ‚ط§ظ†ظˆظ†ظٹ ط£ظˆ ظ…ط´ظƒظ„طھظƒ ط¨ط´ظƒظ„ ظˆط§ط¶ط­ ظˆظ…ط®طھطµط±',
    legalBasisPlaceholder: 'ط¥ظ† ظƒط§ظ† ظ„ط¯ظٹظƒ ط£ط³ط§ط³ ظ†ط¸ط§ظ…ظٹ ط£ظˆ ظ…ظˆط§ط¯ ظ‚ط§ظ†ظˆظ†ظٹط© ط£ظˆ طھظپط§طµظٹظ„ ط¥ط¶ط§ظپظٹط©طŒ ط§ط°ظƒط±ظ‡ط§ ظ‡ظ†ط§',
    uploadHint: 'PDF / طµظˆط± - ظٹظ…ظƒظ†ظƒ ط±ظپط¹ ط£ظƒط«ط± ظ…ظ† ظ…ظ„ظپ',
    requestTypeCase: 'ظ‚ط¶ظٹط©',
    requestTypeExecution: 'طھظ†ظپظٹط°',
    requestTypeConsultation: 'ط§ط³طھط´ط§ط±ط© ظ‚ط§ظ†ظˆظ†ظٹط©',
    requestTypeInsolvency: 'ط¥ظپظ„ط§ط³ / طھطµظپظٹط©',
    requestTypeOther: 'ط£ط®ط±ظ‰',
    serviceOpinion: 'ط±ط£ظٹ ظ‚ط§ظ†ظˆظ†ظٹ',
    serviceLitigation: 'طھظˆظ„ظٹ ط§ظ„ظ‚ط¶ظٹط© / ط§ظ„طھط±ط§ظپط¹',
    serviceFollowup: 'ظ…طھط§ط¨ط¹ط© طھظ†ظپظٹط°',
    serviceDocument: 'ط¥ط¹ط¯ط§ط¯ ظ…ط³طھظ†ط¯ ظ‚ط§ظ†ظˆظ†ظٹ',
    submitSuccess: 'طھظ… ط¥ط±ط³ط§ظ„ ط·ظ„ط¨ظƒ ط¨ظ†ط¬ط§ط­',
    requestNumber: 'ط±ظ‚ظ… ط§ظ„ط·ظ„ط¨',
    requestState: 'ط­ط§ظ„ط© ط§ظ„ط·ظ„ط¨',
    expectedResponse: 'ظˆظ‚طھ ط§ظ„ط±ط¯ ط§ظ„ظ…طھظˆظ‚ط¹',
    requestReceived: 'طھظ… ط§ط³طھظ„ط§ظ… ط§ظ„ط·ظ„ط¨',
    within24Hours: 'ط®ظ„ط§ظ„ 24 ط³ط§ط¹ط© ط¹ظ…ظ„',
    createAnotherRequest: 'ط·ظ„ط¨ ط¬ط¯ظٹط¯',
    close: 'ط¥ط؛ظ„ط§ظ‚',
    requiredField: 'ظ‡ط°ط§ ط§ظ„ط­ظ‚ظ„ ظ…ط·ظ„ظˆط¨',
    issueMinLength: 'ظٹط±ط¬ظ‰ ظƒطھط§ط¨ط© ظˆطµظپ ط£ظˆط¶ط­ ظ„ظ„ظ…ط´ظƒظ„ط©',
    selectedFiles: 'ط§ظ„ظ…ظ„ظپط§طھ ط§ظ„ظ…ط±ظپظˆط¹ط©',
  },
  en: {
    greeting: 'Hello,',
    headerDescription: 'Here you can find the latest updates on your legal files, required actions, and services linked to Wazin.',
    lastActivity: 'Last activity',
    todayAt: 'Today 10:45 AM',
    profile: 'Profile',
    updateData: 'Update details',
    changePhoto: 'Change profile photo',
    switchAccount: 'Switch account / role',
    logout: 'Log out',
    clientAccount: 'Client account',
    cases: 'Cases',
    requests: 'Requests',
    agencies: 'POAs',
    documents: 'Documents',
    role: 'Role',
    status: 'Status',
    latestUpdate: 'Last update',
    nextStep: 'Next step',
    file: 'File',
    noResults: 'No matching results',
    noResultsDesc: 'Try adjusting your search or filter to display other files.',
    addTicket: 'Add ticket',
    addNewCase: 'Add New Case',
    addExecutionRequest: 'New Enforcement Request',
    all: 'All',
    principal: 'Principal',
    agent: 'Agent',
    legalServiceRequest: 'Legal Service Request',
    serviceRequestTitle: 'Legal Service Request',
    requestType: 'Request Type',
    issueDescription: 'Issue Description',
    legalBasis: 'Legal Basis (Optional)',
    attachments: 'Attachments',
    serviceType: 'Requested Service',
    initialAssessment: 'I would like a preliminary assessment before proceeding',
    sendRequest: 'Send Request',
    quoteRequest: 'Request a Quote',
    issuePlaceholder: 'Explain your legal matter or issue clearly and briefly',
    legalBasisPlaceholder: 'If you have any legal basis, articles, or extra details, add them here',
    uploadHint: 'PDF / Images - you may upload multiple files',
    requestTypeCase: 'Case',
    requestTypeExecution: 'Enforcement',
    requestTypeConsultation: 'Legal Consultation',
    requestTypeInsolvency: 'Insolvency / Liquidation',
    requestTypeOther: 'Other',
    serviceOpinion: 'Legal Opinion',
    serviceLitigation: 'Take Over the Case / Litigation',
    serviceFollowup: 'Enforcement Follow-up',
    serviceDocument: 'Prepare a Legal Document',
    submitSuccess: 'Your request has been submitted successfully',
    requestNumber: 'Request Number',
    requestState: 'Request Status',
    expectedResponse: 'Expected Response',
    requestReceived: 'Request Received',
    within24Hours: 'Within 24 business hours',
    createAnotherRequest: 'New Request',
    close: 'Close',
    requiredField: 'This field is required',
    issueMinLength: 'Please provide a clearer issue description',
    selectedFiles: 'Uploaded Files',
  },
};

const ClientDashboardProfessional = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const isEnglish = i18n.language?.startsWith('en');
  const locale = isEnglish ? 'en' : 'ar';

  const [activeTab, setActiveTab] = useState('cases');
  const [poaRoleFilter, setPoaRoleFilter] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isRequestModalOpen, setIsRequestModalOpen] = useState(false);
  const [requestStep, setRequestStep] = useState('form');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submittedRequest, setSubmittedRequest] = useState(null);
  const [requestErrors, setRequestErrors] = useState({});
  const [requestForm, setRequestForm] = useState({
    requestType: 'case',
    issueDescription: '',
    legalBasis: '',
    serviceType: 'opinion',
    needsAssessment: false,
    attachments: [],
  });
  const menuRef = useRef(null);

  const t = LABELS[locale];
  const activeTabMeta = TAB_META[locale][activeTab];
  const requestTypeOptions = [
    { value: 'case', label: t.requestTypeCase },
    { value: 'execution', label: t.requestTypeExecution },
    { value: 'consultation', label: t.requestTypeConsultation },
    { value: 'insolvency', label: t.requestTypeInsolvency },
    { value: 'other', label: t.requestTypeOther },
  ];
  const serviceTypeOptions = [
    { value: 'opinion', label: t.serviceOpinion },
    { value: 'litigation', label: t.serviceLitigation },
    { value: 'followup', label: t.serviceFollowup },
    { value: 'document', label: t.serviceDocument },
  ];

  useEffect(() => {
    if (!isMenuOpen) return undefined;

    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isMenuOpen]);

  const formatDate = (value) => {
    if (!value) return locale === 'ar' ? 'ط؛ظٹط± ظ…ط­ط¯ط¯' : 'Not set';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    return date.toLocaleDateString(locale === 'ar' ? 'ar-SA' : 'en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  const clientName = isEnglish ? 'Ahmed Abdullah Al Salem' : 'أحمد بن عبدالله السالم';
  const accountPanel = {
    title: isEnglish ? 'Client Account' : 'حساب العميل',
    accountTypeLabel: isEnglish ? 'Account Type' : 'نوع الحساب',
    accountTypeValue: isEnglish ? 'Individual' : 'فرد',
    profile: isEnglish ? 'Profile' : 'الملف الشخصي',
    updateProfile: isEnglish ? 'Update Profile' : 'تحديث الملف الشخصي',
    changePhoto: isEnglish ? 'Change Profile Photo' : 'تغيير صورة الحساب',
    switchAccount: isEnglish ? 'Switch Account / Role' : 'تبديل الحساب / الصلاحية',
    logout: isEnglish ? 'Log out' : 'تسجيل الخروج',
    platformTitle: isEnglish ? 'Wazin Digital Platform' : 'منصة وازن الرقمية',
    platformSubtitle: 'Wazin Legal Platform',
  };
  const accountSwitchOptions = isEnglish
    ? ['Individual Account', 'Business Account', 'Employee Account', 'Admin Account']
    : ['حساب فرد', 'حساب أعمال', 'حساب موظف', 'حساب إدارة'];
  const canSwitchAccounts = accountSwitchOptions.length > 1;

  const caseRows = useMemo(
    () => [
      {
        id: mockCases[0]?.id || 'case-1',
        number: mockCases[0]?.caseNumber || 'WZ-2024-001',
        type: isEnglish ? 'Labour Case' : 'ظ‚ط¶ظٹط© ط¹ظ…ط§ظ„ظٹط©',
        role: isEnglish ? 'Claimant' : 'ظ…ط¯ط¹ظٹ',
        counterpart: isEnglish ? 'Advanced Horizons Co.' : 'ط´ط±ظƒط© ط§ظ„ط¢ظپط§ظ‚ ط§ظ„ظ…طھظ‚ط¯ظ…ط©',
        status: isEnglish ? 'In Progress' : 'ظ‚ظٹط¯ ط§ظ„ظ…ط¹ط§ظ„ط¬ط©',
        updatedAt: formatDate(mockCases[0]?.lastUpdate || '2026-04-24'),
        nextStep: isEnglish ? 'Review the response memo before the next hearing.' : 'ظ…ط±ط§ط¬ط¹ط© ظ…ط°ظƒط±ط© ط§ظ„ط±ط¯ ظ‚ط¨ظ„ ط§ظ„ط¬ظ„ط³ط© ط§ظ„ظ‚ط§ط¯ظ…ط©.',
      },
      {
        id: mockCases[1]?.id || 'case-2',
        number: mockCases[1]?.caseNumber || 'WZ-2024-002',
        type: isEnglish ? 'Commercial Case' : 'ظ‚ط¶ظٹط© طھط¬ط§ط±ظٹط©',
        role: isEnglish ? 'Claimant' : 'ظ…ط¯ط¹ظٹ',
        counterpart: isEnglish ? 'United Leadership Foundation' : 'ظ…ط¤ط³ط³ط© ط§ظ„ط±ظٹط§ط¯ط© ط§ظ„ظ…طھط­ط¯ط©',
        status: isEnglish ? 'Awaiting Action' : 'ط¨ط§ظ†طھط¸ط§ط± ط¥ط¬ط±ط§ط،',
        updatedAt: formatDate(mockCases[1]?.lastUpdate || '2026-04-21'),
        nextStep: isEnglish ? 'Approve the uploaded documents before filing.' : 'ط§ط¹طھظ…ط§ط¯ ط§ظ„ظ…ط³طھظ†ط¯ط§طھ ط§ظ„ظ…ط±ظپظˆط¹ط© ظ‚ط¨ظ„ ط¥ط±ط³ط§ظ„ظ‡ط§ ظ„ظ„ظ…ط­ظƒظ…ط©.',
      },
      {
        id: mockCases[2]?.id || 'case-3',
        number: mockCases[2]?.caseNumber || 'WZ-2023-045',
        type: isEnglish ? 'Personal Status Case' : 'ظ‚ط¶ظٹط© ط£ط­ظˆط§ظ„ ط´ط®طµظٹط©',
        role: isEnglish ? 'Respondent' : 'ظ…ط¯ط¹ظ‰ ط¹ظ„ظٹظ‡',
        counterpart: isEnglish ? 'The other family party' : 'ط§ظ„ط·ط±ظپ ط§ظ„ط£ط³ط±ظٹ ط§ظ„ط¢ط®ط±',
        status: isEnglish ? 'Closed' : 'ظ…ط؛ظ„ظ‚ط©',
        updatedAt: formatDate(mockCases[2]?.lastUpdate || '2026-03-14'),
        nextStep: isEnglish ? 'The file has been closed and archived.' : 'طھظ… ط¥ط؛ظ„ط§ظ‚ ط§ظ„ظ…ظ„ظپ ظˆطھط³ظ„ظٹظ… ط§ظ„ظ†طھط§ط¦ط¬ ط§ظ„ظ†ظ‡ط§ط¦ظٹط©.',
      },
    ],
    [isEnglish],
  );

  const executionRows = useMemo(
    () => [
      {
        id: 'exec-1',
        number: isEnglish ? 'ENF-204' : 'طھظ†ظپظٹط°-204',
        type: isEnglish ? 'Financial Enforcement' : 'ط·ظ„ط¨ طھظ†ظپظٹط° ظ…ط§ظ„ظٹ',
        role: isEnglish ? 'Applicant' : 'ط·ط§ظ„ط¨ طھظ†ظپظٹط°',
        counterpart: isEnglish ? 'Al Wifaq Trading Co.' : 'ط´ط±ظƒط© ط§ظ„ظˆظپط§ظ‚ ط§ظ„طھط¬ط§ط±ظٹط©',
        status: isEnglish ? 'In Progress' : 'ظ‚ظٹط¯ ط§ظ„ظ…ط¹ط§ظ„ط¬ط©',
        updatedAt: formatDate('2026-04-24'),
        nextStep: isEnglish ? 'Follow up on the banking disclosure report.' : 'ظ…طھط§ط¨ط¹ط© ظ…ط­ط¶ط± ط§ظ„ط¥ظپطµط§ط­ ط§ظ„ط¨ظ†ظƒظٹ.',
      },
      {
        id: 'exec-2',
        number: isEnglish ? 'ENF-187' : 'طھظ†ظپظٹط°-187',
        type: isEnglish ? 'Instrument Enforcement' : 'ط·ظ„ط¨ طھظ†ظپظٹط° ط³ظ†ط¯',
        role: isEnglish ? 'Applicant' : 'ط·ط§ظ„ط¨ طھظ†ظپظٹط°',
        counterpart: isEnglish ? 'Al Isnad Establishment' : 'ظ…ط¤ط³ط³ط© ط§ظ„ط¥ط³ظ†ط§ط¯',
        status: isEnglish ? 'Awaiting Action' : 'ط¨ط§ظ†طھط¸ط§ط± ط¥ط¬ط±ط§ط،',
        updatedAt: formatDate('2026-04-21'),
        nextStep: isEnglish ? 'Pay the notice fee to proceed.' : 'ط³ط¯ط§ط¯ ط±ط³ظˆظ… ط§ظ„ط¥ط¹ظ„ط§ظ† ظ‚ط¨ظ„ ط§ظ„ط§ط³طھظƒظ…ط§ظ„.',
      },
    ],
    [isEnglish],
  );

  const insolvencyRows = useMemo(
    () => [
      {
        id: 'ins-1',
        number: isEnglish ? 'INS-011' : 'ط¥ظپظ„ط§ط³-011',
        type: isEnglish ? 'Financial Reorganization' : 'ط¥ط¹ط§ط¯ط© طھظ†ط¸ظٹظ… ظ…ط§ظ„ظٹ',
        role: isEnglish ? 'Creditor' : 'ط¯ط§ط¦ظ†',
        counterpart: isEnglish ? 'Development Solutions Co.' : 'ط´ط±ظƒط© ط­ظ„ظˆظ„ ط§ظ„طھط·ظˆظٹط±',
        status: isEnglish ? 'In Progress' : 'ظ‚ظٹط¯ ط§ظ„ظ…ط¹ط§ظ„ط¬ط©',
        updatedAt: formatDate('2026-04-23'),
        nextStep: isEnglish ? 'Attend the restructuring plan session.' : 'ط­ط¶ظˆط± ط¬ظ„ط³ط© ط§ط¹طھظ…ط§ط¯ ط§ظ„ط®ط·ط© ط§ظ„ط£ظˆظ„ظٹط©.',
      },
      {
        id: 'ins-2',
        number: isEnglish ? 'LIQ-007' : 'طھطµظپظٹط©-007',
        type: isEnglish ? 'Liquidation Request' : 'ط·ظ„ط¨ طھطµظپظٹط©',
        role: isEnglish ? 'Interested Party' : 'طµط§ط­ط¨ ظ…طµظ„ط­ط©',
        counterpart: isEnglish ? 'Smart Services Establishment' : 'ظ…ظ†ط´ط£ط© ط§ظ„ط®ط¯ظ…ط§طھ ط§ظ„ط°ظƒظٹط©',
        status: isEnglish ? 'Closed' : 'ظ…ط؛ظ„ظ‚ط©',
        updatedAt: formatDate('2026-03-12'),
        nextStep: isEnglish ? 'All statutory requirements have been completed.' : 'طھظ… ط§ط³طھظƒظ…ط§ظ„ ط§ظ„ظ…طھط·ظ„ط¨ط§طھ ط§ظ„ظ†ط¸ط§ظ…ظٹط© ظˆط¥ط؛ظ„ط§ظ‚ ط§ظ„ظ…ظ„ظپ.',
      },
    ],
    [isEnglish],
  );

  const poaRows = useMemo(
    () => [
      {
        id: powerOfAttorneys[0]?.id || 'poa-1',
        number: isEnglish ? 'POA-001' : 'ظˆظƒط§ظ„ط©-001',
        type: isEnglish ? 'General Power of Attorney' : 'ظˆظƒط§ظ„ط© ط¹ط§ظ…ط©',
        role: isEnglish ? 'Agent' : 'ظˆظƒظٹظ„',
        counterpart: isEnglish ? 'Wazin Law Firm' : 'ظ…ظƒطھط¨ ظˆط§ط²ظ† ظ„ظ„ظ…ط­ط§ظ…ط§ط©',
        status: isEnglish ? 'In Progress' : 'ظ‚ظٹط¯ ط§ظ„ظ…ط¹ط§ظ„ط¬ط©',
        updatedAt: formatDate(powerOfAttorneys[0]?.issueDate || '2026-01-10'),
        nextStep: isEnglish ? 'Review the power scope before renewal.' : 'ظ…ط±ط§ط¬ط¹ط© ظ†ط·ط§ظ‚ ط§ظ„ظˆظƒط§ظ„ط© ظ‚ط¨ظ„ ط§ظ„طھط¬ط¯ظٹط¯.',
        agencyRole: 'agent',
      },
      {
        id: powerOfAttorneys[1]?.id || 'poa-2',
        number: isEnglish ? 'POA-002' : 'ظˆظƒط§ظ„ط©-002',
        type: isEnglish ? 'Special POA - Labour Case' : 'ظˆظƒط§ظ„ط© ط®ط§طµط© - ظ‚ط¶ظٹط© ط¹ظ…ط§ظ„ظٹط©',
        role: isEnglish ? 'Principal' : 'ظ…ظˆظƒظ„',
        counterpart: isEnglish ? 'Lawyer Mohammed Al Otaibi' : 'ط§ظ„ظ…ط­ط§ظ…ظٹ ظ…ط­ظ…ط¯ ط§ظ„ط¹طھظٹط¨ظٹ',
        status: isEnglish ? 'Awaiting Action' : 'ط¨ط§ظ†طھط¸ط§ط± ط¥ط¬ط±ط§ط،',
        updatedAt: formatDate(powerOfAttorneys[1]?.issueDate || '2026-02-15'),
        nextStep: isEnglish ? 'Approve the issued copy and send it to the lawyer.' : 'ط§ط¹طھظ…ط§ط¯ ط§ظ„ظ†ط³ط®ط© ط§ظ„طµط§ط¯ط±ط© ظˆط¥ط±ط³ط§ظ„ظ‡ط§ ظ„ظ„ظ…ط­ط§ظ…ظٹ.',
        agencyRole: 'principal',
      },
    ],
    [isEnglish],
  );

  const ticketRows = useMemo(
    () => [
      {
        id: serviceRequests[0]?.id || 'ticket-1',
        number: isEnglish ? 'TKT-001' : 'طھط°ظƒط±ط©-001',
        type: isEnglish ? 'Complaint' : 'ط´ظƒظˆظ‰ ط¹ظ…ظٹظ„',
        role: isEnglish ? 'Client' : 'ط¹ظ…ظٹظ„',
        counterpart: isEnglish ? 'Client Care Team' : 'ظپط±ظٹظ‚ ط®ط¯ظ…ط© ط§ظ„ط¹ظ…ظ„ط§ط،',
        status: isEnglish ? 'Awaiting Action' : 'ط¨ط§ظ†طھط¸ط§ط± ط¥ط¬ط±ط§ط،',
        updatedAt: formatDate(serviceRequests[0]?.submissionDate || '2026-04-22'),
        nextStep: isEnglish ? 'Your complaint has been escalated for review.' : 'طھظ… طھطµط¹ظٹط¯ ط§ظ„ط´ظƒظˆظ‰ ظ„ظ„ظ…ط±ط§ط¬ط¹ط© ظ„ط¯ظ‰ ط§ظ„ظپط±ظٹظ‚ ط§ظ„ظ…ط®طھطµ.',
      },
      {
        id: serviceRequests[1]?.id || 'ticket-2',
        number: isEnglish ? 'TKT-002' : 'طھط°ظƒط±ط©-002',
        type: isEnglish ? 'Suggestion' : 'ط§ظ‚طھط±ط§ط­ طھط·ظˆظٹط±',
        role: isEnglish ? 'Client' : 'ط¹ظ…ظٹظ„',
        counterpart: isEnglish ? 'Service Quality Team' : 'ظپط±ظٹظ‚ طھط·ظˆظٹط± ط§ظ„ط®ط¯ظ…ط©',
        status: isEnglish ? 'In Progress' : 'ظ‚ظٹط¯ ط§ظ„ظ…ط¹ط§ظ„ط¬ط©',
        updatedAt: formatDate(serviceRequests[1]?.submissionDate || '2026-04-20'),
        nextStep: isEnglish ? 'The suggestion is under internal review.' : 'ط§ظ„ط§ظ‚طھط±ط§ط­ ظ‚ظٹط¯ ط§ظ„ط¯ط±ط§ط³ط© ظ…ط¹ ط§ظ„ظپط±ظٹظ‚ ط§ظ„ط¯ط§ط®ظ„ظٹ.',
      },
    ],
    [isEnglish],
  );

  const tabs = useMemo(
    () => [
      { id: 'cases', label: TAB_META[locale].cases.label, count: caseRows.length, badge: 'bg-emerald-100 text-emerald-700' },
      { id: 'execution', label: TAB_META[locale].execution.label, count: executionRows.length, badge: 'bg-amber-100 text-amber-700' },
      { id: 'insolvency', label: TAB_META[locale].insolvency.label, count: insolvencyRows.length, badge: 'bg-slate-100 text-slate-700' },
      { id: 'poa', label: TAB_META[locale].poa.label, count: poaRows.length, badge: 'bg-slate-100 text-slate-700' },
      { id: 'tickets', label: TAB_META[locale].tickets.label, count: ticketRows.length, badge: 'bg-rose-100 text-rose-700' },
    ],
    [caseRows.length, executionRows.length, insolvencyRows.length, locale, poaRows.length, ticketRows.length],
  );

  const rowsMap = useMemo(
    () => ({
      cases: caseRows,
      execution: executionRows,
      insolvency: insolvencyRows,
      poa: poaRows,
      tickets: ticketRows,
    }),
    [caseRows, executionRows, insolvencyRows, poaRows, ticketRows],
  );

  const filteredRows = useMemo(() => {
    let rows = rowsMap[activeTab] || [];

    if (activeTab === 'poa' && poaRoleFilter !== 'all') {
      rows = rows.filter((row) => row.agencyRole === poaRoleFilter);
    }

    if (searchQuery.trim()) {
      const query = searchQuery.trim().toLowerCase();
      rows = rows.filter((row) =>
        [row.number, row.type, row.counterpart, row.role].some((field) =>
          String(field || '').toLowerCase().includes(query),
        ),
      );
    }

    return rows;
  }, [activeTab, poaRoleFilter, rowsMap, searchQuery]);

  const toggleLanguage = () => {
    const nextLanguage = isEnglish ? 'ar' : 'en';
    i18n.changeLanguage(nextLanguage);
    document.documentElement.dir = nextLanguage === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = nextLanguage;
  };

  const openRequestModal = (requestType = 'case') => {
    setIsRequestModalOpen(true);
    setRequestStep('form');
    setSubmittedRequest(null);
    setRequestErrors({});
    setRequestForm((previous) => ({
      ...previous,
      requestType,
    }));
  };

  const closeRequestModal = () => {
    setIsRequestModalOpen(false);
    setIsSubmitting(false);
  };

  const contextualAction = useMemo(() => {
    if (activeTab === 'cases') {
      return {
        label: t.addNewCase,
        icon: FilePlus2,
        onClick: () => openRequestModal('case'),
      };
    }

    if (activeTab === 'execution') {
      return {
        label: t.addExecutionRequest,
        icon: Plus,
        onClick: () => openRequestModal('execution'),
      };
    }

    if (activeTab === 'tickets') {
      return {
        label: t.addTicket,
        icon: MessageSquarePlus,
        onClick: () => openRequestModal('other'),
      };
    }

    return null;
  }, [activeTab, t.addExecutionRequest, t.addNewCase, t.addTicket]);

  const handleRequestField = (field, value) => {
    setRequestForm((previous) => ({
      ...previous,
      [field]: value,
    }));

    setRequestErrors((previous) => {
      if (!previous[field]) return previous;
      const nextErrors = { ...previous };
      delete nextErrors[field];
      return nextErrors;
    });
  };

  const handleAttachmentChange = (event) => {
    const files = Array.from(event.target.files || []);
    handleRequestField('attachments', files);
  };

  const validateRequestForm = () => {
    const errors = {};

    if (!requestForm.requestType) {
      errors.requestType = t.requiredField;
    }

    if (!requestForm.issueDescription.trim()) {
      errors.issueDescription = t.requiredField;
    } else if (requestForm.issueDescription.trim().length < 15) {
      errors.issueDescription = t.issueMinLength;
    }

    if (!requestForm.serviceType) {
      errors.serviceType = t.requiredField;
    }

    setRequestErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmitRequest = async (event) => {
    event.preventDefault();

    if (!validateRequestForm()) return;

    setIsSubmitting(true);

    await new Promise((resolve) => {
      window.setTimeout(resolve, 900);
    });

    const requestId = `WR-${new Date().getFullYear()}-${Math.floor(1000 + Math.random() * 9000)}`;

    setSubmittedRequest({
      id: requestId,
      status: t.requestReceived,
      responseTime: t.within24Hours,
    });
    setRequestStep('success');
    setIsSubmitting(false);
  };

  const goToCase = (number) => navigate(`/client/case/${number}`);

  const handleLogout = () => {
    localStorage.removeItem('wazin-auth-token');
    localStorage.removeItem('wazin-user-data');
    navigate('/portals');
  };

  return (
    <div className="relative min-h-screen overflow-hidden bg-[#F7F9FB] pb-12" dir={isEnglish ? 'ltr' : 'rtl'}>
      <img
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute left-[-10%] top-24 w-[420px] select-none opacity-[0.05]"
        src="/images/wazin-mark.png"
      />
      <img
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute bottom-20 right-[-10%] w-[520px] select-none opacity-[0.04]"
        src="/images/wazin-mark.png"
      />

      <div className="mx-auto w-full max-w-[1300px] px-4 pt-7 lg:px-8">
        <section className="relative z-30 overflow-visible rounded-[30px] bg-[linear-gradient(135deg,#1F8A70_0%,#236E63_46%,#0F2742_100%)] px-5 py-4 text-white shadow-[0_18px_50px_rgba(15,39,66,0.14)] lg:px-7">
          <img
            alt=""
            aria-hidden="true"
            className="pointer-events-none absolute top-1/2 w-[360px] -translate-y-1/2 select-none opacity-[0.055]"
            style={isEnglish ? { left: 32 } : { right: 32 }}
            src="/images/wazin-mark.png"
          />

          <div className={`relative flex items-center justify-between gap-4 ${isEnglish ? 'flex-row' : 'flex-row-reverse'}`}>
            <div className="order-2 flex items-center gap-3">
              <div ref={menuRef} className="relative z-[220]">
                <button
                  className="flex items-center gap-2 rounded-full border border-white/15 bg-white/8 px-4 py-2.5 text-sm font-semibold text-white backdrop-blur-md transition hover:bg-white/14"
                  type="button"
                  onClick={() => setIsMenuOpen((previous) => !previous)}
                >
                  <Menu className="h-4 w-4" />
                  <ChevronDown className={`h-4 w-4 transition ${isMenuOpen ? 'rotate-180' : ''}`} />
                </button>

                {isMenuOpen && (
                  <div
                    className={`absolute top-[calc(100%+12px)] z-[240] w-80 overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-[0_28px_80px_rgba(15,39,66,0.18)] ${
                      isEnglish ? 'right-0' : 'left-0'
                    }`}
                  >
                    <div className="border-b border-slate-100 px-5 py-4">
                      <p className="text-sm text-slate-500">{accountPanel.title}</p>
                      <div className="mt-3 flex items-center gap-3">
                        <div className="flex h-11 w-11 items-center justify-center rounded-full bg-slate-100 text-slate-600">
                          <UserRound className="h-5 w-5" />
                        </div>
                        <div className="min-w-0">
                          <p className="truncate text-base font-bold text-slate-900">{clientName}</p>
                          <p className="mt-1 text-xs text-slate-500">
                            {accountPanel.accountTypeLabel}: {accountPanel.accountTypeValue}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="space-y-1 p-3 text-sm text-slate-700">
                      <button className="flex w-full items-center justify-between rounded-2xl px-4 py-3 transition hover:bg-slate-50" type="button">
                        <span>{accountPanel.profile}</span>
                        <UserRound className="h-4 w-4" />
                      </button>
                      <button className="flex w-full items-center justify-between rounded-2xl px-4 py-3 transition hover:bg-slate-50" type="button">
                        <span>{accountPanel.updateProfile}</span>
                        <FileText className="h-4 w-4" />
                      </button>
                      <button className="flex w-full items-center justify-between rounded-2xl px-4 py-3 transition hover:bg-slate-50" type="button">
                        <span>{accountPanel.changePhoto}</span>
                        <UserRound className="h-4 w-4" />
                      </button>
                      {canSwitchAccounts && (
                        <button className="flex w-full items-center justify-between rounded-2xl px-4 py-3 transition hover:bg-slate-50" type="button">
                          <span>{accountPanel.switchAccount}</span>
                          <ShieldCheck className="h-4 w-4" />
                        </button>
                      )}
                      <button
                        className="flex w-full items-center justify-between rounded-2xl px-4 py-3 text-rose-600 transition hover:bg-rose-50"
                        type="button"
                        onClick={handleLogout}
                      >
                        <span>{accountPanel.logout}</span>
                        <LogOut className="h-4 w-4" />
                      </button>
                    </div>
                  </div>
                )}
              </div>

              <button
                className="relative rounded-full border border-white/12 bg-white/8 p-3 text-white backdrop-blur-md transition hover:bg-white/14"
                type="button"
              >
                <Bell className="h-5 w-5" />
                <span className="absolute -right-1 -top-1 flex h-6 min-w-6 items-center justify-center rounded-full bg-[#1F8A70] px-1 text-xs font-bold text-white">
                  3
                </span>
              </button>

              <button
                className="rounded-full border border-white/12 bg-white/8 px-4 py-2.5 text-sm font-semibold text-white backdrop-blur-md transition hover:bg-white/14"
                type="button"
                onClick={toggleLanguage}
              >
                {isEnglish ? 'AR | EN' : 'العربية | EN'}
              </button>
            </div>

            <div className="order-1 flex shrink-0 items-center gap-4 rounded-[26px] border border-white/15 bg-white/10 px-5 py-3 backdrop-blur-md">
              <div className={isEnglish ? 'text-left' : 'text-right'}>
                <div className="text-[1.2rem] font-black leading-none text-[#F2DFB0] lg:text-[1.4rem]">{accountPanel.platformTitle}</div>
                <div className="mt-1.5 text-sm font-semibold tracking-wide text-white/90 lg:text-[15px]">{accountPanel.platformSubtitle}</div>
              </div>
              <div className="flex h-14 w-14 items-center justify-center rounded-[22px] border-2 border-[#C8A45C] bg-white/95 shadow-[0_16px_35px_rgba(15,39,66,0.18)]">
                <img src={WAZIN_ICON_URL} alt="Wazin" className="h-9 w-9 object-contain" />
              </div>
            </div>
          </div>
        </section>

        <section className="relative z-10 mt-4 mb-8 rounded-[28px] border border-white bg-white/90 px-5 py-4 shadow-[0_22px_50px_rgba(15,39,66,0.10)] backdrop-blur-xl">
          <div className="flex flex-col gap-3 xl:flex-row xl:items-center xl:justify-between">
            <div className={`flex flex-wrap items-center gap-3 ${isEnglish ? 'xl:order-2' : 'xl:order-1'}`}>
              {tabs.map((tab) => {
                const active = activeTab === tab.id;
                return (
                  <button
                    key={tab.id}
                    className={`inline-flex items-center gap-3 rounded-full border px-4 py-3 text-sm font-bold transition ${
                      active
                        ? 'border-[#0F2742] bg-[#0F2742] text-white shadow-[0_12px_24px_rgba(15,39,66,0.18)]'
                        : 'border-slate-200 bg-white text-slate-700 hover:-translate-y-0.5 hover:border-[#C8A45C] hover:text-[#0F2742]'
                    }`}
                    type="button"
                    onClick={() => setActiveTab(tab.id)}
                  >
                    <span>{tab.label}</span>
                    <span className={`rounded-full px-2.5 py-1 text-xs font-bold ${active ? 'bg-white/12 text-white' : tab.badge}`}>
                      {tab.count}
                    </span>
                  </button>
                );
              })}
            </div>

            <div className={`${isEnglish ? 'xl:order-1' : 'xl:order-2'} flex items-center`}>
              {contextualAction ? (
                <button
                  className="inline-flex items-center justify-center gap-3 rounded-full bg-[#1F8A70] px-4 py-2.5 text-sm font-bold text-white shadow-[0_14px_28px_rgba(31,138,112,0.24)] transition hover:-translate-y-0.5 hover:bg-[#18725d] hover:shadow-[0_18px_36px_rgba(31,138,112,0.28)]"
                  type="button"
                  onClick={contextualAction.onClick}
                >
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-white/16 text-white">
                    <contextualAction.icon className="h-4 w-4" />
                  </span>
                  <span>{contextualAction.label}</span>
                </button>
              ) : null}
            </div>
          </div>
        </section>

        <section className="rounded-[32px] border border-[#E6ECF2] bg-white px-6 py-6 shadow-[0_24px_60px_rgba(15,39,66,0.08)]">
          <div className="mb-6 flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
            <div className={`text-${isEnglish ? 'left' : 'right'}`}>
              <h2 className="text-3xl font-extrabold text-[#0F2742]">{activeTabMeta.title}</h2>
              <p className="mt-2 text-sm text-slate-500">{activeTabMeta.description}</p>
            </div>

            <div className="flex flex-col gap-3 lg:min-w-[520px]">
              <div className="relative">
                <Search className={`pointer-events-none absolute top-1/2 h-5 w-5 -translate-y-1/2 text-slate-400 ${isEnglish ? 'left-4' : 'right-4'}`} />
                <input
                  className={`w-full rounded-2xl border border-slate-200 bg-[#F7F9FB] py-3 text-sm text-slate-700 outline-none transition focus:border-[#1F8A70] focus:bg-white focus:ring-2 focus:ring-[#1F8A70]/10 ${isEnglish ? 'pl-12 pr-4 text-left' : 'pr-12 pl-4 text-right'}`}
                  placeholder={activeTabMeta.searchPlaceholder}
                  type="text"
                  value={searchQuery}
                  onChange={(event) => setSearchQuery(event.target.value)}
                />
              </div>

              <div className={`flex flex-wrap items-center gap-3 ${isEnglish ? 'justify-end' : 'justify-end'}`}>
                <div className={`flex flex-wrap items-center gap-2 ${isEnglish ? 'justify-end' : 'justify-end'}`}>
                  {activeTab === 'poa' && (
                    <div className="flex items-center gap-2 rounded-full border border-slate-200 bg-[#F7F9FB] p-1">
                      {[
                        { id: 'all', label: t.all },
                        { id: 'agent', label: t.agent },
                        { id: 'principal', label: t.principal },
                      ].map((item) => {
                        const active = poaRoleFilter === item.id;
                        return (
                          <button
                            key={item.id}
                            className={`rounded-full px-4 py-2 text-sm font-semibold transition ${
                              active ? 'bg-[#0F2742] text-white shadow-sm' : 'text-slate-600 hover:bg-white'
                            }`}
                            type="button"
                            onClick={() => setPoaRoleFilter(item.id)}
                          >
                            {item.label}
                          </button>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="overflow-hidden rounded-[28px] border border-slate-200 bg-[#FBFCFD]">
            <div className="hidden grid-cols-[1.1fr_1fr_0.8fr_1fr_0.9fr_0.9fr_1.1fr_0.35fr] gap-4 border-b border-slate-200 bg-[#F7F9FB] px-6 py-4 text-xs font-bold tracking-wide text-slate-500 lg:grid">
              <div className={`text-${isEnglish ? 'left' : 'right'}`}>#{isEnglish ? 'File Number' : 'ط±ظ‚ظ… ط§ظ„ظ…ظ„ظپ'}</div>
              <div className={`text-${isEnglish ? 'left' : 'right'}`}>{activeTabMeta.typeLabel}</div>
              <div className={`text-${isEnglish ? 'left' : 'right'}`}>{t.role}</div>
              <div className={`text-${isEnglish ? 'left' : 'right'}`}>{activeTabMeta.counterpartLabel}</div>
              <div className={`text-${isEnglish ? 'left' : 'right'}`}>{t.status}</div>
              <div className={`text-${isEnglish ? 'left' : 'right'}`}>{t.latestUpdate}</div>
              <div className={`text-${isEnglish ? 'left' : 'right'}`}>{t.nextStep}</div>
              <div className={`text-${isEnglish ? 'left' : 'right'}`}>{t.file}</div>
            </div>

            <div className="divide-y divide-slate-100">
              {filteredRows.map((row) => {
                const stateMap = STATUS_STYLES[locale];
                const state = stateMap[row.status] || stateMap[Object.keys(stateMap)[0]];

                return (
                  <button
                    key={row.id}
                    className="grid w-full grid-cols-1 gap-4 px-6 py-5 text-right transition hover:bg-[#FCFDFE] lg:grid-cols-[1.1fr_1fr_0.8fr_1fr_0.9fr_0.9fr_1.1fr_0.35fr]"
                    type="button"
                    onClick={() => goToCase(row.number)}
                  >
                    <div>
                      <div className="text-xs text-slate-400 lg:hidden">#{isEnglish ? 'File Number' : 'ط±ظ‚ظ… ط§ظ„ظ…ظ„ظپ'}</div>
                      <div className="text-sm font-extrabold text-[#0F2742]">{row.number}</div>
                    </div>
                    <div>
                      <div className="text-xs text-slate-400 lg:hidden">{activeTabMeta.typeLabel}</div>
                      <div className="font-bold text-[#0F2742]">{row.type}</div>
                    </div>
                    <div>
                      <div className="text-xs text-slate-400 lg:hidden">{t.role}</div>
                      <div className="text-slate-600">{row.role}</div>
                    </div>
                    <div>
                      <div className="text-xs text-slate-400 lg:hidden">{activeTabMeta.counterpartLabel}</div>
                      <div className="text-slate-600">{row.counterpart}</div>
                    </div>
                    <div>
                      <div className="text-xs text-slate-400 lg:hidden">{t.status}</div>
                      <div className={`inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-xs font-bold ${state.tone}`}>
                        <span className={`h-2.5 w-2.5 rounded-full ${state.dot}`} />
                        {row.status}
                      </div>
                    </div>
                    <div>
                      <div className="text-xs text-slate-400 lg:hidden">{t.latestUpdate}</div>
                      <div className="text-slate-500">{row.updatedAt}</div>
                    </div>
                    <div>
                      <div className="text-xs text-slate-400 lg:hidden">{t.nextStep}</div>
                      <div className="text-slate-600">{row.nextStep}</div>
                    </div>
                    <div className={`flex ${isEnglish ? 'justify-start' : 'justify-end'}`}>
                      <span className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 bg-white text-[#0F2742] shadow-sm">
                        <ArrowLeft className={`h-4 w-4 ${isEnglish ? 'rotate-180' : ''}`} />
                      </span>
                    </div>
                  </button>
                );
              })}

              {!filteredRows.length && (
                <div className="px-6 py-14 text-center">
                  <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-3xl bg-[#EEF4FB] text-[#0F2742]">
                    <FileText className="h-7 w-7" />
                  </div>
                  <h3 className="mt-4 text-xl font-bold text-[#0F2742]">{t.noResults}</h3>
                  <p className="mt-2 text-sm text-slate-500">{t.noResultsDesc}</p>
                </div>
              )}
            </div>
          </div>
        </section>
      </div>

      {isRequestModalOpen && (
        <div className="fixed inset-0 z-[320] flex items-center justify-center bg-[#0F2742]/45 px-4 py-8 backdrop-blur-sm">
          <div className="relative max-h-[92vh] w-full max-w-4xl overflow-hidden rounded-[32px] border border-white/70 bg-white shadow-[0_36px_90px_rgba(15,39,66,0.24)]">
            <div className="flex items-center justify-between border-b border-slate-100 bg-[linear-gradient(135deg,#F7F9FB_0%,#FFFFFF_100%)] px-6 py-5">
              <div className={`text-${isEnglish ? 'left' : 'right'}`}>
                <h3 className="text-2xl font-extrabold text-[#0F2742]">{t.serviceRequestTitle}</h3>
                <p className="mt-1 text-sm text-slate-500">{t.issuePlaceholder}</p>
              </div>
              <button
                className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-slate-200 text-slate-500 transition hover:border-slate-300 hover:bg-slate-50 hover:text-slate-700"
                type="button"
                onClick={closeRequestModal}
              >
                <X className="h-5 w-5" />
              </button>
            </div>

            <div className="max-h-[calc(92vh-88px)] overflow-y-auto px-6 py-6">
              {requestStep === 'success' ? (
                <div className="space-y-6 py-8 text-center">
                  <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-[28px] bg-[#E8F5F2] text-[#1F8A70] shadow-inner">
                    <ShieldCheck className="h-10 w-10" />
                  </div>
                  <div>
                    <h4 className="text-3xl font-extrabold text-[#0F2742]">{t.submitSuccess}</h4>
                    <p className="mt-2 text-sm text-slate-500">{t.headerDescription}</p>
                  </div>

                  <div className="grid gap-4 md:grid-cols-3">
                    <div className="rounded-[24px] border border-slate-200 bg-[#F7F9FB] p-5">
                      <p className="text-sm text-slate-500">{t.requestNumber}</p>
                      <p className="mt-2 text-lg font-extrabold text-[#0F2742]">{submittedRequest?.id}</p>
                    </div>
                    <div className="rounded-[24px] border border-slate-200 bg-[#F7F9FB] p-5">
                      <p className="text-sm text-slate-500">{t.requestState}</p>
                      <p className="mt-2 text-lg font-extrabold text-[#1F8A70]">{submittedRequest?.status}</p>
                    </div>
                    <div className="rounded-[24px] border border-slate-200 bg-[#F7F9FB] p-5">
                      <p className="text-sm text-slate-500">{t.expectedResponse}</p>
                      <p className="mt-2 text-lg font-extrabold text-[#C8A45C]">{submittedRequest?.responseTime}</p>
                    </div>
                  </div>

                  <div className="flex flex-wrap items-center justify-center gap-3">
                    <button
                      className="inline-flex items-center gap-2 rounded-full bg-[#0F2742] px-5 py-3 text-sm font-bold text-white transition hover:bg-[#133456]"
                      type="button"
                      onClick={() => {
                        setRequestForm({
                          requestType: 'case',
                          issueDescription: '',
                          legalBasis: '',
                          serviceType: 'opinion',
                          needsAssessment: false,
                          attachments: [],
                        });
                        setRequestErrors({});
                        setSubmittedRequest(null);
                        setRequestStep('form');
                      }}
                    >
                      <Plus className="h-4 w-4" />
                      {t.createAnotherRequest}
                    </button>
                    <button
                      className="inline-flex items-center gap-2 rounded-full border border-slate-200 px-5 py-3 text-sm font-bold text-slate-700 transition hover:bg-slate-50"
                      type="button"
                      onClick={closeRequestModal}
                    >
                      {t.close}
                    </button>
                  </div>
                </div>
              ) : (
                <form className="space-y-6" onSubmit={handleSubmitRequest}>
                  <div className="grid gap-5 md:grid-cols-2">
                    <label className={`block text-${isEnglish ? 'left' : 'right'}`}>
                      <span className="mb-2 block text-sm font-bold text-[#0F2742]">{t.requestType}</span>
                      <select
                        className={`w-full rounded-2xl border ${requestErrors.requestType ? 'border-rose-300' : 'border-slate-200'} bg-[#F7F9FB] px-4 py-3 text-sm text-slate-700 outline-none transition focus:border-[#1F8A70] focus:bg-white focus:ring-2 focus:ring-[#1F8A70]/10`}
                        value={requestForm.requestType}
                        onChange={(event) => handleRequestField('requestType', event.target.value)}
                      >
                        {requestTypeOptions.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                      {requestErrors.requestType && <span className="mt-2 block text-xs text-rose-600">{requestErrors.requestType}</span>}
                    </label>

                    <div className={`text-${isEnglish ? 'left' : 'right'}`}>
                      <span className="mb-2 block text-sm font-bold text-[#0F2742]">{t.serviceType}</span>
                      <div className="grid gap-2 sm:grid-cols-2">
                        {serviceTypeOptions.map((option) => {
                          const active = requestForm.serviceType === option.value;
                          return (
                            <button
                              key={option.value}
                              className={`rounded-2xl border px-4 py-3 text-sm font-semibold transition ${
                                active
                                  ? 'border-[#0F2742] bg-[#0F2742] text-white shadow-[0_10px_20px_rgba(15,39,66,0.12)]'
                                  : 'border-slate-200 bg-[#F7F9FB] text-slate-700 hover:border-[#C8A45C] hover:bg-white'
                              }`}
                              type="button"
                              onClick={() => handleRequestField('serviceType', option.value)}
                            >
                              {option.label}
                            </button>
                          );
                        })}
                      </div>
                      {requestErrors.serviceType && <span className="mt-2 block text-xs text-rose-600">{requestErrors.serviceType}</span>}
                    </div>
                  </div>

                  <label className={`block text-${isEnglish ? 'left' : 'right'}`}>
                    <div className="mb-2 flex items-center justify-between gap-3">
                      <span className="text-sm font-bold text-[#0F2742]">{t.issueDescription}</span>
                      <span className="text-xs font-semibold text-slate-400">{requestForm.issueDescription.length} / 8000</span>
                    </div>
                    <textarea
                      className={`min-h-[180px] w-full rounded-[24px] border ${requestErrors.issueDescription ? 'border-rose-300' : 'border-slate-200'} bg-[#F7F9FB] px-4 py-4 text-sm leading-7 text-slate-700 outline-none transition focus:border-[#1F8A70] focus:bg-white focus:ring-2 focus:ring-[#1F8A70]/10`}
                      maxLength={8000}
                      placeholder={t.issuePlaceholder}
                      value={requestForm.issueDescription}
                      onChange={(event) => handleRequestField('issueDescription', event.target.value)}
                    />
                    {requestErrors.issueDescription && <span className="mt-2 block text-xs text-rose-600">{requestErrors.issueDescription}</span>}
                  </label>

                  <label className={`block text-${isEnglish ? 'left' : 'right'}`}>
                    <div className="mb-2 flex items-center justify-between gap-3">
                      <span className="text-sm font-bold text-[#0F2742]">{t.legalBasis}</span>
                      <span className="text-xs font-semibold text-slate-400">{requestForm.legalBasis.length} / 1000</span>
                    </div>
                    <textarea
                      className="min-h-[120px] w-full rounded-[24px] border border-slate-200 bg-[#F7F9FB] px-4 py-4 text-sm leading-7 text-slate-700 outline-none transition focus:border-[#1F8A70] focus:bg-white focus:ring-2 focus:ring-[#1F8A70]/10"
                      maxLength={1000}
                      placeholder={t.legalBasisPlaceholder}
                      value={requestForm.legalBasis}
                      onChange={(event) => handleRequestField('legalBasis', event.target.value)}
                    />
                  </label>

                  <div className={`text-${isEnglish ? 'left' : 'right'}`}>
                    <span className="mb-2 block text-sm font-bold text-[#0F2742]">{t.attachments}</span>
                    <label className="flex cursor-pointer flex-col items-center justify-center gap-3 rounded-[24px] border border-dashed border-slate-300 bg-[#F7F9FB] px-5 py-8 text-center transition hover:border-[#1F8A70] hover:bg-white">
                      <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#E8F5F2] text-[#1F8A70]">
                        <Upload className="h-6 w-6" />
                      </div>
                      <div>
                        <p className="text-sm font-bold text-[#0F2742]">{t.attachments}</p>
                        <p className="mt-1 text-xs text-slate-500">{t.uploadHint}</p>
                      </div>
                      <input
                        accept=".pdf,image/*"
                        className="hidden"
                        multiple
                        type="file"
                        onChange={handleAttachmentChange}
                      />
                    </label>

                    {!!requestForm.attachments.length && (
                      <div className="mt-3 rounded-[20px] border border-slate-200 bg-white p-4">
                        <p className="mb-2 text-xs font-bold text-slate-500">{t.selectedFiles}</p>
                        <div className="space-y-2">
                          {requestForm.attachments.map((file) => (
                            <div key={`${file.name}-${file.lastModified}`} className="flex items-center justify-between gap-3 rounded-2xl bg-[#F7F9FB] px-3 py-2 text-sm text-slate-600">
                              <span className="truncate">{file.name}</span>
                              <span className="shrink-0 text-xs text-slate-400">{Math.round(file.size / 1024)} KB</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>

                  <label className="flex items-center gap-3 rounded-2xl border border-slate-200 bg-[#F7F9FB] px-4 py-3 text-sm font-semibold text-slate-700">
                    <input
                      checked={requestForm.needsAssessment}
                      className="h-4 w-4 rounded border-slate-300 text-[#1F8A70] focus:ring-[#1F8A70]"
                      type="checkbox"
                      onChange={(event) => handleRequestField('needsAssessment', event.target.checked)}
                    />
                    <span>{t.initialAssessment}</span>
                  </label>

                  <div className="flex flex-wrap items-center justify-between gap-3 border-t border-slate-100 pt-2">
                    <button
                      className="inline-flex items-center gap-2 rounded-full bg-[#0F2742] px-6 py-3 text-sm font-bold text-white shadow-[0_14px_28px_rgba(15,39,66,0.18)] transition hover:bg-[#143250] disabled:cursor-not-allowed disabled:opacity-70"
                      disabled={isSubmitting}
                      type="submit"
                    >
                      {isSubmitting ? <Upload className="h-4 w-4 animate-pulse" /> : <FilePlus2 className="h-4 w-4" />}
                      {t.quoteRequest}
                    </button>
                    <button
                      className="inline-flex items-center gap-2 rounded-full border border-slate-200 px-5 py-3 text-sm font-bold text-slate-700 transition hover:bg-slate-50"
                      type="button"
                      onClick={closeRequestModal}
                    >
                      {t.close}
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientDashboardProfessional;
